import { z } from 'zod'
import {
  contentDataSchema,
  errorDataSchema,
  eventDataSchema,
} from '../common.schema'

export const GenericErrorSchema = z.object({
  event: z.literal('generic_error'),

  content_data: contentDataSchema.optional(),
  event_data: eventDataSchema,
  error_data: errorDataSchema,
})

export type GenericErrorEvent = z.infer<typeof GenericErrorSchema>
